import {Observable} from "rxjs/Rx";
import {INotificationCatalogueExamenWebServiceClient} from "./../../../../../common/resources/resources";
import {Injectable} from "@angular/core";
import {Resolve} from "@angular/router";

@Injectable()
export class AlertesMisesAJourResolver implements Resolve<number> {

  constructor(private notificationCatalogueService: INotificationCatalogueExamenWebServiceClient) {
  }

  resolve() {
    return this.notificationCatalogueService.countNotificationsMisesAjour().catch(response => {
      return Observable.of(0);
    });
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/src/app/pages/cerba/pages/catalogue-examens/resultats/alertes-mises-a-jour.resolver.ts